import React, { useState } from "react";



// (StarRating and SeatIndicator remain exactly as you wrote them)
function StarRating({ rating }) {
  return (
    <div className="star-rating">
      {[1,2,3,4,5].map((s) => (
        <svg key={s} width="10" height="10" viewBox="0 0 24 24"
          fill={s <= Math.round(rating) ? "#f59e0b" : "none"}
          stroke={s <= Math.round(rating) ? "#f59e0b" : "#3a3a4a"}
          strokeWidth="2">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
        </svg>
      ))}
      <span className="rating-num">{rating}</span>
    </div>
  );
}

function SeatIndicator({ seats }) {
  const level = seats <= 5 ? "critical" : seats <= 10 ? "low" : "ok";
  const label = seats <= 5 ? `Only ${seats} left!` : seats <= 10 ? `${seats} seats left` : `${seats} seats`;
  return (
    <div className={`seat-indicator seat-indicator--${level}`}>
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
      </svg>
      {label}
    </div>
  );
}

// --- EXTENDED PROPS: added isRecommended, onCompare, isComparing ---
function FlightCard({ flight, onSelectFlight, isSelected, isCheapest, isFastest, index, isRecommended, onCompare, isComparing }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={`flight-card ${isSelected ? "flight-card--selected" : ""} ${hovered ? "flight-card--hovered" : ""}`}
      style={{ animationDelay: `${index * 60}ms` }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => onSelectFlight(flight)}
    >
      {/* Badges */}
      <div className="card-badges">
        {/* --- NEW: 1. Recommended Badge --- */}
        {isRecommended && <span className="badge badge--recommended">⭐ Recommended for you</span>}
        {isCheapest && <span className="badge badge--green">Best Price</span>}
        {isFastest && <span className="badge badge--blue">Fastest</span>}
        {flight.class === "Business" && <span className="badge badge--gold">Business</span>}
      </div>

      {/* Airline Info */}
      <div className="card-airline">
        <div className="airline-logo" style={{ background: `${flight.color}18`, borderColor: `${flight.color}30` }}>
          <span style={{ color: flight.color, fontSize: "18px" }}>✈</span>
        </div>
        <div>
          <div className="airline-name">{flight.airline}</div>
          <div className="airline-code">{flight.code}</div>
        </div>
        <div className="card-right">
          <div className="flight-price">₹{flight.price.toLocaleString()}</div>
          {/* --- NEW: 2. Price Trends --- */}
          <div className={`price-insight ${flight.price < 4000 ? 'trend-good' : 'trend-bad'}`}>
            {flight.price < 4000 ? "🔥 12% cheaper than avg" : "⚠ Prices may increase"}
          </div>
        </div>
      </div>

      {/* Route (Original Unchanged) */}
      <div className="card-route">
        <div className="route-point">
          <div className="route-time">{flight.departure}</div>
          <div className="route-city">{flight.from}</div>
          <div className="route-code">{flight.fromCode}</div>
        </div>
        <div className="route-line">
          <div className="route-stops">{flight.stops}</div>
          <div className="route-track">
            <div className="route-dot" />
            <div className="route-dashes" />
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8"/>
            </svg>
          </div>
          <div className="route-duration">{flight.duration}</div>
        </div>
        <div className="route-point route-point--right">
          <div className="route-time">{flight.arrival}</div>
          <div className="route-city">{flight.to}</div>
          <div className="route-code">{flight.toCode}</div>
        </div>
      </div>

      {/* --- NEW: 4. Why This Flight Section --- */}
      {isRecommended && (
        <div className="why-this-flight">
          <div className="why-label">Why this?</div>
          <div className="why-item">✔ Best balance of price & duration</div>
          <div className="why-item">✔ High rating from travelers</div>
          <div className="why-item">✔ {flight.seats > 10 ? 'Good' : 'Limited'} seat availability</div>
        </div>
      )}

      {/* Footer */}
      <div className="card-footer">
        <StarRating rating={flight.rating} />
        <SeatIndicator seats={flight.seats} />
        
        {/* --- NEW: 3. Compare Button --- */}
        <button 
          className={`compare-trigger-btn ${isComparing ? 'active' : ''}`}
          onClick={(e) => { e.stopPropagation(); onCompare(); }}
        >
          {isComparing ? "Selected" : "⚖ Compare"}
        </button>

        <button
          className={`select-btn ${isSelected ? "select-btn--selected" : ""}`}
          onClick={(e) => { e.stopPropagation(); onSelectFlight(flight); }}
        >
          {isSelected ? (
            <>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              Selected
            </>
          ) : "Select →"}
        </button>
      </div>
    </div>
  );
}

export default FlightCard;